












































































































import Vue from 'vue';
import PLocationViewModel from './p-location.vue.model';

export default Vue.extend({
  name: 'PLocation',
  props: {
    defaultLatitude: { default: 0, type: Number },
    defaultLongitude: { default: 0, type: Number },
    zoom: { default: 18, type: Number },
    setMarker: { default: true, type: Boolean },
  },
  data: () => ({
    vm: new PLocationViewModel(),
    isDefaultLatitudeSet: false as boolean,
    isDefaultLongitudeSet: false as boolean,
  }),
  watch: {
    defaultLatitude: {
      immediate: true,
      handler(val) {
        if (!this.isDefaultLatitudeSet) {
          this.vm.latitude = val;
          this.vm.updateGoogleMap();
          this.isDefaultLatitudeSet = true;
        }
      },
    },
    defaultLongitude: {
      immediate: true,
      handler(val) {
        if (!this.isDefaultLongitudeSet) {
          this.vm.longitude = val;
          this.vm.updateGoogleMap();
          this.isDefaultLongitudeSet = true;
        }
      },
    },
  },
  mounted() {
    const Window = window as any;
    this.vm.googleWindow = Window.google;
    this.vm.initializeGoogleMapsApiKey();
    this.vm.zoom = this.zoom;
    this.vm.setMarker = this.setMarker;

    this.$nextTick(() => {
      this.vm.mapHtmlElement = this.$refs.pLocationMap as HTMLElement;
      this.vm.initializeGoogleMaps();
    });
  },
  methods: {
    setEditMode() {
      this.vm.isInEditMode = true;
      this.vm.previousLatitude = this.vm.latitude;
      this.vm.previousLongitude = this.vm.longitude;
      Vue.nextTick(() => {
        this.vm.map.setOptions({ disableDefaultUI: false });
        this.setupMapSearch();
      });
    },
    onSave() {
      this.vm.updateGoogleMap();
      this.vm.setViewMode();
      this.$emit('latitudeChange', this.vm.latitude);
      this.$emit('longitudeChange', this.vm.longitude);
    },
    setupMapSearch() {
      this.vm.searchBox = new this.vm.googleWindow.maps.places.SearchBox(this.$refs.searchField as HTMLInputElement);

      this.vm.googleWindow.maps.event.addListener(this.vm.searchBox, 'places_changed', () => {
        const searchResult = this.vm.searchBox.getPlaces();

        if (searchResult === undefined || searchResult.length === 0) {
          return;
        }

        const searchResultLat = searchResult[0].geometry?.location?.lat();
        const searchResultLng = searchResult[0].geometry?.location?.lng();

        if (searchResultLat && searchResultLng) {
          const panPoint = new this.vm.googleWindow.maps.LatLng(searchResultLat, searchResultLng);
          this.vm.map.panTo(panPoint);
        }
      });
    },
  },
});
